import { checkListsAPI } from "./api";

export const getCheckListsList = async () => {
    try {
      const res = await checkListsAPI.getCheckListsList();
      return res?.data
    } catch (e) {}
  };

export const updateCheckList = async (data) => {
  try {
    const res = await checkListsAPI.updateCheckList(data);
    return res?.data;
  } catch (e) {
    throw e;
  }
};

export const deleteCheckList = async (checkListId) => {
  try {
    await checkListsAPI.deleteCheckList(checkListId);
    return true;
  } catch (e) {
    throw e;
  }
};

export const checkListsTableColumns = [
  {
    name: "check_list_id",
    required: true,
    label: "ID",
    align: "center",
    field: "check_list_id",
    sortable: true,
  },
  {
    name: "check_name",
    required: true,
    label: "Наименование",
    align: "left",
    field: "check_name",
    sortable: true,
  },
  {
    name: "is_active",
    required: true,
    label: "Активный",
    align: "center",
    field: "is_active",
    sortable: true,
  },
  {
    name: "norm",
    required: true,
    label: "Норма",
    align: "center",
    field: "norm",
    sortable: true,
  },
  {
    name: "actions",
    label: "Действия",
    align: "center",
    field: "actions",
  },
  {
    name: "actions",
    label: "",
    align: "center",
    field: "actions",
  },
];
